<div class="rule-container"
    [ngClass]="{ 'first': first, 'last': last, 'disabled': isDisabled, 'no-edit': noEditAllowed }">

    <form [formGroup]="propertyFilterForm" fxLayout="column" role="form" (ngSubmit)="onApply()">

        <div class="rule-header" style="display: flex; align-items: center;">

            <!-- Autocomplete field -->
            <mat-form-field *ngIf="!chosen" class="search-input" style="flex: 1;">
                <input matInput [placeholder]="'Select a property to filter on' | translate" [formControl]="searchControl"
                    [matAutocomplete]="auto" required autocomplete="off">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event.option.value)"
                    [displayWith]="displayFn">
                    <mat-option *ngFor="let prop of filteredProperties" [ngClass]="{ 'subheader-option': prop.subheader }" [value]="prop">
                        <!-- Show subheader-like option if needed -->
                        <ng-container *ngIf="prop.subheader; else suggestionTpl">
                            <div class="sfx-autocomplete-subheader">
                                <div fxLayout="row">
                                    <span class="status">{{ prop.title }}</span>
                                    <div fxFlex></div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #suggestionTpl>
                            <div class="md-filter-suggestion">
                                <div fxLayout="row">
                                    <span class="mat-filter-name"
                                        [innerHTML]="highlight(prop.label + getLabelExtension(prop), searchControl.value)"></span>
                                    <div fxFlex></div>
                                </div>
                            </div>
                        </ng-template>
                    </mat-option>
                </mat-autocomplete>
                <!-- Error messages can be handled with Angular Material's error state or mat-hint -->
                <mat-error *ngIf="searchControl.hasError('required')">
                    <span translate>A value is required.</span>
                </mat-error>
            </mat-form-field>

            <!-- If a property has been chosen, show its name -->
            <h3 *ngIf="chosen" style="flex: 1; margin: 0;">
                {{ property.display_name }}
            </h3>
            <button mat-icon-button *ngIf="!noEditAllowed && !fixedRule" (click)="delete()">
                <mat-icon fontSet="salesflare" fontIcon="sf-icon-delete" class="icon-22"></mat-icon>
            </button>
        </div>

        <!-- Rule content -->
        <div class="rule-content" *ngIf="chosen" fxLayout="row">

            <!-- Operator component -->
            <sfx-filters-operator style="width: 100%;" *ngIf="!showPipelineNotice()" [fixedRule]="fixedRule" [property]="property" [filterFields]="filterFields"
                [propertyChanged]="boundOnPropertyChange" [apply]="onApply" [isDisabled]="isDisabled"
                [noEditAllowed]="noEditAllowed">
            </sfx-filters-operator>

            <!-- Pipeline notice -->
            <div *ngIf="showPipelineNotice()">
                {{ getPipelineNoticeText() }}
            </div>

        </div>

    </form>
</div>